import React, { useEffect, useState } from 'react';
import { Plus, Edit2, Trash2, Save, Zap, Eye, EyeOff } from 'lucide-react';
import { adminApi, publicApi } from '../../api';
import { PageHeader, Table, Modal, Field, Input, Select, ImageUpload } from './AdminUI';

const EMPTY = {
  title: '', description: '', promo_text: '',
  activity_id: '', activity_slug: '', city_slug: '',
  image: '', link_url: '',
  starts_at: '', expires_at: '',
  is_active: true, order: 0
};

export default function AdminFlashOffers() {
  const [items, setItems] = useState([]);
  const [cities, setCities] = useState([]);
  const [editing, setEditing] = useState(null);

  const load = () => adminApi.offers().then(setItems);
  useEffect(() => { load(); publicApi.cities().then(setCities); }, []);

  const save = async (e) => {
    e.preventDefault();
    if (!editing.title || !editing.expires_at) { alert('Titolo e data di scadenza sono obbligatori'); return; }
    const payload = {
      title: editing.title, description: editing.description || null, promo_text: editing.promo_text || null,
      activity_id: editing.activity_id || null, activity_slug: editing.activity_slug || null,
      city_slug: editing.city_slug || null, image: editing.image || null, link_url: editing.link_url || null,
      starts_at: editing.starts_at || null, expires_at: editing.expires_at,
      is_active: !!editing.is_active, order: Number(editing.order) || 0
    };
    if (editing.id) await adminApi.updateOffer(editing.id, payload);
    else await adminApi.createOffer(payload);
    setEditing(null); load();
  };

  const del = async (row) => {
    if (!window.confirm(`Eliminare "${row.title}"?`)) return;
    await adminApi.deleteOffer(row.id); load();
  };

  return (
    <div>
      <PageHeader title="Offerte Flash" subtitle={`${items.length} offerte configurate — countdown live nelle pagine città`}
        action={<button onClick={() => setEditing({...EMPTY})} className="btn-primary flex items-center gap-2" data-testid="admin-offer-new-btn"><Plus size={16}/> Nuova offerta</button>}
      />

      <Table
        columns={[
          { key: 'promo_text', label: 'Promo', render: r => r.promo_text ? <span className="px-2 py-0.5 rounded-full text-xs font-bold bg-amber-100 text-amber-900">{r.promo_text}</span> : '—' },
          { key: 'title', label: 'Titolo' },
          { key: 'expires_at', label: 'Scade', render: r => r.expires_at ? new Date(r.expires_at).toLocaleString('it-IT') : '—' },
          { key: 'city_slug', label: 'Città', render: r => r.city_slug || 'Tutte' },
          { key: 'is_active', label: 'Stato', render: r => (
            <span className={`inline-flex items-center gap-1 px-2 py-1 rounded text-xs font-semibold ${r.is_active ? 'bg-green-100 text-green-800' : 'bg-gray-200 text-gray-600'}`}>
              {r.is_active ? <><Eye size={12}/> Attiva</> : <><EyeOff size={12}/> Off</>}
            </span>
          )}
        ]}
        rows={items}
        actions={row => (
          <div className="flex gap-2 justify-end">
            <button onClick={() => setEditing({...row})} className="p-1.5 hover:bg-gray-100 rounded text-blue-600"><Edit2 size={15}/></button>
            <button onClick={() => del(row)} className="p-1.5 hover:bg-gray-100 rounded text-red-600"><Trash2 size={15}/></button>
          </div>
        )}
      />

      <Modal open={!!editing} onClose={() => setEditing(null)} title={editing?.id ? 'Modifica offerta' : 'Nuova offerta'} maxWidth="max-w-2xl">
        {editing && (
          <form onSubmit={save}>
            <Field label="Titolo *"><Input required value={editing.title} onChange={e => setEditing({...editing, title: e.target.value})} placeholder="Es. Aperitivo 2x1 al tramonto"/></Field>
            <Field label="Descrizione"><Input value={editing.description || ''} onChange={e => setEditing({...editing, description: e.target.value})}/></Field>
            <div className="grid grid-cols-2 gap-3">
              <Field label="Testo promo (badge)"><Input value={editing.promo_text || ''} onChange={e => setEditing({...editing, promo_text: e.target.value})} placeholder="-30% / 2x1"/></Field>
              <Field label="Città">
                <Select value={editing.city_slug || ''} onChange={e => setEditing({...editing, city_slug: e.target.value})}>
                  <option value="">Tutte le città</option>
                  {cities.map(c => <option key={c.slug} value={c.slug}>{c.name}</option>)}
                </Select>
              </Field>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <Field label="Data inizio (opzionale)"><Input type="datetime-local" value={editing.starts_at ? String(editing.starts_at).slice(0,16) : ''} onChange={e => setEditing({...editing, starts_at: e.target.value ? new Date(e.target.value).toISOString() : ''})}/></Field>
              <Field label="Data scadenza *"><Input required type="datetime-local" value={editing.expires_at ? String(editing.expires_at).slice(0,16) : ''} onChange={e => setEditing({...editing, expires_at: e.target.value ? new Date(e.target.value).toISOString() : ''})}/></Field>
            </div>
            <Field label="Link"><Input value={editing.link_url || ''} onChange={e => setEditing({...editing, link_url: e.target.value})} placeholder="https://..."/></Field>
            <Field label="Immagine (opzionale)"><ImageUpload value={editing.image || ''} onChange={v => setEditing({...editing, image: v})}/></Field>
            <label className="flex items-center gap-2 mt-3"><input type="checkbox" checked={!!editing.is_active} onChange={e => setEditing({...editing, is_active: e.target.checked})}/> Attiva</label>
            <div className="flex justify-end gap-2 mt-6">
              <button type="button" onClick={() => setEditing(null)} className="px-4 py-2 border border-gray-300 rounded-md">Annulla</button>
              <button type="submit" className="btn-primary flex items-center gap-2"><Save size={16}/> Salva</button>
            </div>
          </form>
        )}
      </Modal>
    </div>
  );
}
